import { useEffect, useState } from "react";
import { FormAndListCustomFields } from "./components/FormAndListCustomFields";
import { useNavigate } from "react-router-dom";
import usePermission from "../../../hooks/usePermission";
import { FeatureStatic } from "../../../@types/statics/feature.static";
import vectorIcon from "../../../assets/_VectorIcon_.svg";
import styles from "./styles.module.scss";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MuiButton from "@mui/material/Button";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const CustomFields: React.FC = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.customFields.id);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
    }
  }, []);

  return (
    <div className={styles.customFields}>
      <div className={styles.back}>
        <MuiButton
          className={styles.buttonMui}
          onClick={() => navigate("/configurations")}
        >
          {vectorIcon && <img src={vectorIcon} />}
          Voltar a tela anterior
        </MuiButton>
      </div>
      <div className={styles.title}>
        <h1>Personalização de Campos</h1>
      </div>
      <div>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            classes={{
              indicator: styles["MuiTabs-indicator"],
            }}
          >
            <Tab label="Projetos" {...a11yProps(0)} className={styles.tab} />
            <Tab label="Clientes" {...a11yProps(1)} className={styles.tab} />
            <Tab
              label="Colaboradores"
              {...a11yProps(2)}
              className={styles.tab}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <FormAndListCustomFields page="projects" />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FormAndListCustomFields page="customers" />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <FormAndListCustomFields page="resources" />
        </CustomTabPanel>
      </div>
    </div>
  );
};
